var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.486.48C5.407.48.48 5.413.48 11.5c0 6.086 4.928 11.02 11.007 11.02 6.08 0 11.008-4.934 11.008-11.02 0-6.086-4.929-11.02-11.008-11.02z",
    transform: "translate(-61 -545) translate(20 515) translate(27 16) translate(14.015 14) translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.476 16.157L6.605 10.377 11.499 6.806 16.393 10.377 14.524 16.157zM15.668 1.336L11.499 3.118 7.33 1.336M3.181 4.363L3.581 8.897.604 12.329M2.19 17.229L6.606 18.247 8.936 22.151M14.065 22.151L16.393 18.246 20.808 17.227M22.395 12.327L19.416 8.895 19.816 4.363M11.499 3.118L11.499 6.806M16.393 10.52L19.416 8.895M14.524 16.157L16.393 18.246M8.476 16.157L6.606 18.248M3.581 8.897L6.605 10.377",
    transform: "translate(-61 -545) translate(20 515) translate(27 16) translate(14.015 14) translate(.5 .5)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSport);
export default __webpack_public_path__ + "static/media/sport.1f4c9101.svg";
export { ForwardRef as ReactComponent };